export const THROW_ERROR = 'THROW_ERROR'
export const TOKEN_OBTAINED = 'TOKEN_OBTAINED'
export const PROFILE_OBTAINED = 'PROFILE_OBTAINED'
export const TOPTRACKS_OBTAINED = 'TOPTRACKS_OBTAINED'
export const TOPARTISTS_OBTAINED = 'TOPARTISTS_OBTAINED'